import bnafar from './bnafar'
import cns from './cns'
import ria from './ria'
import rira from './rira'
import esus from './esus'
import erpsaude from './erpsaude'

export default baseUrl => {
    baseUrl = `${baseUrl}/integracao`

    return {
        bnafar: bnafar(baseUrl),
        cns: cns(baseUrl),
        ria: ria(baseUrl),
        rira: rira(baseUrl),
        esus: esus(baseUrl),
        erpsaude: erpsaude(baseUrl),
    }
}
